import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'
import type { Note } from '@shared/types'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function initials(name: string) {
  return name
    .split(/\s+/)
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase()
}

export function stripMarkdown(value: string) {
  return value
    .replace(/<[^>]+>/g, '')
    .replace(/[`*_#>~\[\]()!-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export function hasNoteContent(note: Pick<Note, 'title' | 'bodyMarkdown'>) {
  return Boolean(note.title.trim() || stripMarkdown(note.bodyMarkdown))
}
